import React from 'react'
import { Button as MUIButton } from '@material-ui/core'
import { useStyles } from './styles'

const Button = ({
  type = 'primary', width = 'auto', disabled = false, minWidth, small = false, height, className = '', onClick, children,
}) => {
  const classes = useStyles({
    type, width, minWidth, small, height,
  })

  return (
    <MUIButton
      className={`${classes.button} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </MUIButton>
  )
}

export default Button
